function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
  fill: "#EAA622"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.55,
  d: "M119.738 62.1685L92.9272 41.707L26.3418 84.1461L53.6184 118.988C56.0784 119.288 58.5984 119.469 61.1784 119.469C93.0984 119.469 119.078 93.9685 119.738 62.1685Z",
  fill: "#BF830D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.1383 94.7959H44.8379V96.2186H76.1383V94.7959Z",
  fill: "#CCCCCC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M70.4487 94.7961H50.5303L51.953 84.8369H69.0259L70.4487 94.7961Z",
  fill: "#CBCBCB"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6335 77.7236V83.4146C94.6335 84.1971 93.9933 84.8374 93.2108 84.8374H27.7645C26.982 84.8374 26.3418 84.1971 26.3418 83.4146V77.7236H94.6335Z",
  fill: "#D7D7D7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.7873 35.041H29.1865V74.8779H91.7873V35.041Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M93.2108 32.1953H27.7645C26.982 32.1953 26.3418 32.8355 26.3418 33.6181V77.7231H94.6335V33.6181C94.6335 32.8355 93.9933 32.1953 93.2108 32.1953ZM91.788 74.8776H29.1873V35.0408H91.788V74.8776Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M81.8288 39.3086H39.1465V56.3815H81.8288V39.3086Z",
  fill: "#D7D7D7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M81.8305 60.6494H61.9121V62.0722H81.8305V60.6494Z",
  fill: "#CCCCCC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M81.8305 64.918H61.9121V66.3407H81.8305V64.918Z",
  fill: "#CCCCCC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M81.8305 69.1865H61.9121V70.6093H81.8305V69.1865Z",
  fill: "#CCCCCC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M57.6422 60.6494H39.1465V70.6086H57.6422V60.6494Z",
  fill: "#D7D7D7"
});

var SvgOneTimeGift = function SvgOneTimeGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOneTimeGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/one_time_gift.01773839.svg";
export { ForwardRef as ReactComponent };